import {
  smallTableHeaderStyle,
  smallTableRowTextStyle,
} from "@/components/tableComponents/tableStyles";
import { tw } from "@/utils";
import dayjs from "dayjs";
import FollowUpIcon from "@/assets/followUpIcon.svg?react";
import { MedicalHistory } from "./types";
import { symptomCodeMap } from "@/data/symptom";
import { hospitalNameToShort } from "@/data/hospital";

interface MedicalHistoryInfoProps {
  data: MedicalHistory[];
}

export const MedicalHistoryInfo = (props: MedicalHistoryInfoProps) => {
  const { data } = props;

  if (data.length === 0) {
    return (
      <div className="text-base font-regular text-gray-g300 mt-[10px] ml-[10px]">
        - 최근 진료 이력이 없습니다.
      </div>
    );
  }

  return (
    <div
      className={tw(
        "w-full h-fit mt-[10px]",
        "border-solid border-[1px] border-gray-g30 rounded-[6px]"
      )}
    >
      <div className={tw(smallTableHeaderStyle)}>
        <div className="flex-90">진단일시</div>
        <div className="flex-180">병원명</div>
        <div className="flex-240">진단명</div>
      </div>
      <div className="h-[calc(100%-34px)] w-full overflow-auto">
        {data.length !== 0 &&
          data.map((history) => (
            <div className={tw(smallTableRowTextStyle(), "h-[58px]")}>
              <div className="flex-90">
                {dayjs(history.diagDt).format("YY-MM-DD")}
              </div>
              <div className="flex-180">
                <div className="w-full h-full flex items-center gap-[6px]">
                  {history.isFollowUp && (
                    <FollowUpIcon className="w-[16px] h-[16px]" />
                  )}
                  <div className="leading-[22px]">
                    {hospitalNameToShort[history.hospitalName]}
                  </div>
                </div>
              </div>
              <div className="flex-240">
                <div className="w-full h-full flex flex-col justify-center">
                  <div className="leading-[22px]">
                    {symptomCodeMap[history.mainDiagCode]}
                  </div>
                  {/* <div className="text-xs font-medium text-gray-g100 leading-[16px]">
                  {history.mainDiagCode}
                </div> */}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
